var map = {
	"./awba.png": "3db3",
	"./cbbank.png": "6084",
	"./dksh.png": "a711",
	"./heineken.png": "df9e",
	"./huawei.png": "e382",
	"./kbz.png": "fa22",
	"./mab.png": "282e",
	"./mega.png": "75b6",
	"./realme.png": "7704",
	"./reuters.png": "0afc",
	"./samsung.png": "1f1a",
	"./telenor.png": "62d2",
	"./wavemoney.png": "0e94"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bbcd";